<template>
  <div id="container" style="height: 90vh; width: 90vw;"></div>
</template>

<script>
import Graph from "graphology";
import Sigma from "sigma";
// import nodes from '../assets/nodes.json'
// import edges from '../assets/edges.json'
// import { createNodeBorderProgram } from "@sigma/node-border";
// import { createNodePiechartProgram } from "@sigma/node-piechart";
//import { onMounted } from "vue";
// import { DEFAULT_NODE_PROGRAM_CLASSES } from "sigma/settings";
import data from '../assets/data.json';



export default {
  name: 'vueGraph',
  props: {
    colors: {
      type: Object,
      default() {
        return {
          "S_color": '#000000',
          "T_color": '#000000',
          "u_color": '#000000',
          "uk_color": '#000000',
          "avoid_color": '#000000',
          "rehabilitate_color": '#000000',
          "offset_color": '#000000',
          "replace_color": '#000000',
          "minimise_color": '#000000',
          "Built_environment_color": '#000000',
          "Education_color": '#000000',
          "Energy_color": '#000000',
          "LULUCF_color": '#000000',
          "Transport_color": '#000000',
          "Finance_color": '#000000',
          "Geoengineering_color": '#000000',
          "listOfSectors": ['Built environment', 'Education', 'Energy', 'Finance', 'Geoengineering', 'Industry', 'LULUCF', 'Transport'],
          "listTechSocial": ['S', 'T'],
          "listOfHierarchy": ['avoid', 'replace', 'rehabilitate', 'minimise', 'offset'],
        }
      }
    }
  },
  mounted() {

  // let nodeObject = Object.fromEntries(nodes.nIDs.map(k => [k, {}]))
  for(let i = 0; i < data.nodes.length; i++) {
  //  data.nodes[i].label = nodes.labels[i]
    data.nodes[i].short_label = data.nodes[i].key.substring(0, 10) + '...'
  //  data.nodes[i].tech_social = nodes.tech_social[i]
  //  data.nodes[i].strategy_mechanism = nodes.strategy_mechanism[i]
  //  data.nodes[i].hierarchy = nodes.hierarchy[i]
  //  data.nodes[i].sector = nodes.sector[i]
}

// const maxDepths = Object.fromEntries(nodes.nIDs.map(k => [k, Infinity]))
// const xValues = Object.fromEntries(nodes.nIDs.map(k => [k, Infinity]))
// const yValues = Object.fromEntries(nodes.nIDs.map(k => [k, Infinity]))
// maxDepths['0'] = 0
// let totalMaxDepth = 0

// console.log(this.colors)

// const S_color = this.colors.S_color
// const T_color = this.colors.T_color
// const u_color = this.colors.u_color
// const uk_color = this.colors.uk_color
// const avoid_color = this.colors.avoid_color
// const rehabilitate_color = this.colors.rehabilitate_color
// const offset_color = this.colors.offset_color
// const replace_color = this.colors.replace_color
// const minimise_color = this.colors.minimise_color
// const Built_environment_color = this.colors.Built_environment_color
// const Education_color = this.colors.Education_color
// const Energy_color = this.colors.Energy_color
// const LULUCF_color = this.colors.LULUCF_color
// const Transport_color = this.colors.Transport_color
// const Finance_color = this.colors.Finance_color
// const Geoengineering_color = this.colors.Geoengineering_color
// const Industry_color = this.colors.Industry_color

// const listOfSectors = this.colors.listOfSectors
// const listTechSocial = this.colors.listTechSocial
// const listOfHierarchy = this.colors.listOfHierarchy
// const sector_opts = [Built_environment_color, Education_color, Energy_color, Finance_color, Geoengineering_color, Industry_color, LULUCF_color, Transport_color]
// const t_s_opts = [S_color, T_color]
// const hierarchy_opts = [avoid_color, replace_color, rehabilitate_color, minimise_color, offset_color]
// console.log(sector_opts)

// function getFormatting(strategy_mechanism, stringOfCats, category) {
//   if (strategy_mechanism == 'm') {
//     return { size: 4, colors: [u_color] }
//   }
//   else {
//     let colors_list = []
//     switch (category) {
//       case 'sector':
//         listOfSectors.forEach((x, i) => (stringOfCats.includes(x) ? colors_list.push(sector_opts[i]) : null));
//         break
//       case 's-t':
//         listTechSocial.forEach((x, i) => (stringOfCats.includes(x) ? colors_list.push(t_s_opts[i]) : null));
//         break
//       case 'hierarchy':
//         listOfHierarchy.forEach((x, i) => (stringOfCats.includes(x) ? colors_list.push(hierarchy_opts[i]) : null));
//         break
//     }
//     if (colors_list.length == 0) { colors_list.push(uk_color) }
//     return { size: 10, colors: colors_list };
//   }


// }



// function getParents(nID) {
//   let parents = []
//   for (let i = 0; i < edges.startIDs.length; i++) {
//     if (edges.startIDs[i] == nID) {
//       parents.push(edges.endIDs[i])
//     }
//   }
//   return parents
// }

// function getChildren(nID) {
//   let children = []
//   for (let i = 0; i < edges.endIDs.length; i++) {
//     if (edges.endIDs[i] == nID) {
//       children.push(edges.startIDs[i])
//     }
//   }
//   return children
// }

// function returnMaxDepth(nID) {
//   if (maxDepths[nID] != Infinity) {
//     return maxDepths[nID]
//   }
//   // find parents
//   let parents = getParents(nID)

//   // find max depths of parents
//   let maxDepth = 0
//   for (let j = 0; j < parents.length; j++) {
//     maxDepth = Math.max(returnMaxDepth(parents[j]), maxDepth)
//   }

//   // return max max depth of parents + 1 , also write to maxDepths
//   let tmpResult = (maxDepth + 1)
//   maxDepths[nID] = tmpResult
//   totalMaxDepth = Math.max(totalMaxDepth, tmpResult)
//   return tmpResult
// }

// for (let i = 0; i < nodes.nIDs.length; i++) {
//   returnMaxDepth(nodes.nIDs[i])
// }

// // arrange nodes in rows by their depth
// const rowMatrix = Array.from(Array(totalMaxDepth + 1), () => []);

// // get y and x values for each node
// for (let i = 0; i < nodes.nIDs.length; i++) {
//   rowMatrix[maxDepths[nodes.nIDs[i]]].push(nodes.nIDs[i])
// }

// let maxy = 1.5
// let miny = -0.5
// let dx = 0.04

// xValues['0'] = 0
// yValues['0'] = maxy - (maxy - miny) * 0 / rowMatrix.length

// // go from top row down:
// for (let iRow = 1; iRow < rowMatrix.length; iRow++) {

//   let yRow = maxy - (maxy - miny) * iRow / rowMatrix.length
//   let amountBumped = 0;
//   let actualX = Infinity
//   let desiredX = []
//   for (let index = 0; index < rowMatrix[iRow].length; index++) {

//     // get parents' x values and average them for desired x
//     let parents = getParents(rowMatrix[iRow][index])
//     let xTotal = 0;
//     for (let j = 0; j < parents.length; j++) {
//       xTotal = xTotal + xValues[parents[j]]
//     }
//     desiredX.push(xTotal / parents.length);

//   }

//   // rank array, rearrange array
//   let rowCopy = [...rowMatrix[iRow]]
//   // rank desiredX, but rearrange rowCopy also
//   let indices = [...Array(desiredX.length).keys()]
//   indices.sort((a, b) => desiredX[b] - desiredX[a])
//   for (let index = 0; index < rowCopy.length; index++) {
//     rowCopy[index] = rowMatrix[iRow][indices[index]]
//   }
//   desiredX.sort((a, b) => b - a)

//   for (let index = 0; index < rowCopy.length; index++) {

//     if (index == 0) {
//       actualX = desiredX[index]
//     }
//     else {
//       // bump across to the left
//       actualX = Math.min(desiredX[index], (actualX - dx)) // note that actualX is from the previous node
//       amountBumped += actualX - desiredX[index]
//     }
//     xValues[rowCopy[index]] = actualX

//   }

//   // add up amount bumped, divide by how many, shift to the right
//   let xCorrection = amountBumped / rowMatrix[iRow].length
//   for (let index = 0; index < rowMatrix[iRow].length; index++) {
//     xValues[rowMatrix[iRow][index]] = xValues[rowMatrix[iRow][index]] - xCorrection;
//     yValues[rowMatrix[iRow][index]] = yRow

//   }


// }


// let alpha = 0.6
// // pass now from bottom up
// for (let iRow = rowMatrix.length - 2; iRow > -1; iRow--) {

//   let amountBumped = 0;
//   let actualX = Infinity
//   let desiredX = []
//   for (let index = 0; index < rowMatrix[iRow].length; index++) {

//     // get children's x values and average them for desired x
//     let children = getChildren(rowMatrix[iRow][index])
//     if (children.length > 0) {
//       let xTotal = 0;
//       for (let j = 0; j < children.length; j++) {
//         xTotal = xTotal + xValues[children[j]]
//       }
//       desiredX.push(alpha * (xTotal / children.length) + (1 - alpha) * (xValues[rowMatrix[iRow][index]]));
//     } else {
//       let parents = getParents(rowMatrix[iRow][index])
//       let xTotal = 0;
//       for (let j = 0; j < parents.length; j++) {
//         xTotal = xTotal + xValues[parents[j]]
//       }
//       desiredX.push(alpha * (xTotal / parents.length) + (1 - alpha) * (xValues[rowMatrix[iRow][index]]));
//     }

//   }

//   // rank array, rearrange array
//   let rowCopy = [...rowMatrix[iRow]]
//   // rank desiredX, but rearrange rowCopy also
//   let indices = [...Array(desiredX.length).keys()]
//   indices.sort((a, b) => desiredX[b] - desiredX[a])
//   for (let index = 0; index < rowCopy.length; index++) {
//     rowCopy[index] = rowMatrix[iRow][indices[index]]
//   }
//   desiredX.sort((a, b) => b - a)


//   for (let index = 0; index < rowCopy.length; index++) {

//     if (index == 0) {
//       actualX = desiredX[index]
//     }
//     else {
//       // bump across to the left
//       actualX = Math.min(desiredX[index], (actualX - dx)) // note that actualX is from the previous node
//       amountBumped += actualX - desiredX[index]
//     }
//     xValues[rowCopy[index]] = actualX

//   }

//   // add up amount bumped, divide by how many, shift to the right
//   let xCorrection = amountBumped / rowMatrix[iRow].length
//   for (let index = 0; index < rowMatrix[iRow].length; index++) {
//     xValues[rowMatrix[iRow][index]] = xValues[rowMatrix[iRow][index]] - xCorrection;
//   }

// }

// const nodeProgramClasses = { ...DEFAULT_NODE_PROGRAM_CLASSES };
// for (let i = 2; i <= 7; i++) {
//   let slices = [{ color: { attribute: "color" }, value: { value: 1 } }];
//   for (let j = 1; j < i; j++) slices.push({ color: { attribute: `color-sector-${j}` }, value: { value: 1 } });
//   nodeProgramClasses[`pie-sector-${i}`] = createNodePiechartProgram({
//     slices,
//   });
// }

// for (let i = 2; i <= 2; i++) {
//   let slices = [{ color: { attribute: "color" }, value: { value: 1 } }];
//   for (let j = 1; j < i; j++) slices.push({ color: { attribute: `color-s-t-${j}` }, value: { value: 1 } });
//   nodeProgramClasses[`pie-s-t-${i}`] = createNodePiechartProgram({
//     slices,
//   });
// }

// for (let i = 2; i <= 5; i++) {
//   let slices = [{ color: { attribute: "color" }, value: { value: 1 } }];
//   for (let j = 1; j < i; j++) slices.push({ color: { attribute: `color-hierarchy-${j}` }, value: { value: 1 } });
//   nodeProgramClasses[`pie-hierarchy-${i}`] = createNodePiechartProgram({
//     slices,
//   });
// }



const graph = new Graph();
  graph.import(data);
const sigmaInstance = new Sigma(graph, document.getElementById("container"), {
  // renderEdgeLabels: true, 
  enableEdgeClickEvents: true, enableEdgeEvents: true, 
  zIndex: true
  // labelColor: { color: "#555555" }, defaultNodeType: "circle",
  // nodeProgramClasses,
});



sigmaInstance.refresh()
// console.log(nodeProgramClasses)

// function updateColors(coloring) {
//   for (let i = 0; i < nodes.nIDs.length; i++) {
//     let formattingOpts = []
//     switch (coloring) {
//       case 'sector':
//         formattingOpts = getFormatting(nodes.strategy_mechanism[i], nodes.sector[i], 'sector')
//         break
//       case 's-t':
//         formattingOpts = getFormatting(nodes.strategy_mechanism[i], nodes.tech_social[i], 's-t')
//         break
//       case 'hierarchy':
//         formattingOpts = getFormatting(nodes.strategy_mechanism[i], nodes.hierarchy[i], 'hierarchy')
//         break
//     }

//     if (formattingOpts.colors.length == 1) {
//       graph.setNodeAttribute(nodes.nIDs[i], "color", formattingOpts.colors[0])
//       graph.setNodeAttribute(nodes.nIDs[i], "type", 'circle')
//     }
//     else {
//       graph.setNodeAttribute(nodes.nIDs[i], "type", `pie-${coloring}-${formattingOpts.colors.length}`)
//       graph.setNodeAttribute(nodes.nIDs[i], "color", formattingOpts.colors[0])
//       console.log(nodes.nIDs[i])
//       console.log(formattingOpts.colors)

//     }

//   }
//   return 0
// }


function getNodesAndEdgesAssociated(nodeID, depth) {
  let outputtedEdges = []
  let nodesToCheck = [nodeID]
  let outputtedNodes = [nodeID]
  for (var i = 0; i < depth; i++) {
    let nextLevelNodes = []
    for (var j = 0; j < nodesToCheck.length; j++ ) {
      let nodeInQuestion = nodesToCheck[j]
      let arrayEdges = graph.edges(nodeInQuestion)
      for (let k = 0; k < arrayEdges.length; k++) {
        if (! outputtedEdges.includes(arrayEdges[k])) {
          outputtedEdges.push(arrayEdges[k])
          if ((! nextLevelNodes.includes(graph.source(arrayEdges[k]))) & (! outputtedNodes.includes(graph.source(arrayEdges[k]))) ) {
            nextLevelNodes.push(graph.source(arrayEdges[k]))
          }
          else if ((! nextLevelNodes.includes(graph.target(arrayEdges[k]))) & (! outputtedNodes.includes(graph.target(arrayEdges[k]))) ){
            nextLevelNodes.push(graph.target(arrayEdges[k]))
          }
        }
      }
    }
    outputtedNodes = outputtedNodes.concat(nextLevelNodes)
    nodesToCheck = nextLevelNodes
    
  }
  // console.log(outputtedNodes)
  // console.log(outputtedEdges)
  return [outputtedNodes, outputtedEdges]
}

function highlightEdges(listOfEdges) {
  for (let i = 0; i < listOfEdges.length; i++) {
    graph.setEdgeAttribute(listOfEdges[i], "highlighted", true)
    graph.setEdgeAttribute(listOfEdges[i], "zIndex", 100)
    graph.setEdgeAttribute(listOfEdges[i], "color", "purple")
 //   graph.setEdgeAttribute(listOfEdges[i], "forceLabel", true)
  }
}

function dehighlightEdges(listOfEdges) {
  for (let i = 0; i < listOfEdges.length; i++) {
    dehighlightEdge(listOfEdges[i])
  }
}

function dehighlightEdge(edge) {
    graph.setEdgeAttribute(edge, "highlighted", false)
    graph.setEdgeAttribute(edge, "zIndex", 1)
    graph.setEdgeAttribute(edge, "color", "#e0e0e0")
  //  graph.setEdgeAttribute(listOfEdges[i], "forceLabel", false)
}

function highlightNodes(listOfUsedNodes) {
  for (let i = 0; i < listOfUsedNodes.length; i++) {
    graph.setNodeAttribute(listOfUsedNodes[i], "highlighted", true)
   // graph.setNodeAttribute(listOfUsedNodes[i], "forceLabel", true)
  //  graph.setNodeAttribute(listOfUsedNodes[i], "label", graph.nodes[i].label)
  }
}
function dehighlightNodes(listOfUsedNodes) {
  for (let i = 0; i < listOfUsedNodes.length; i++) {
   // graph.setNodeAttribute(listOfUsedNodes[i], "forceLabel", false)
    // console.log(graph.getNodeAttributes('TNO'))
  //  graph.setNodeAttribute(listOfUsedNodes[i], "label", graph.nodes[i].label)
    dehighlightNode(listOfUsedNodes[i])
  }
}

function dehighlightNode(node) {
  graph.setNodeAttribute(node, "highlighted", false)
}

// function visibliseEdges(listOfEdges) {
//   for (let i = 0; i < listOfEdges.length; i++) {
//     graph.setEdgeAttribute(listOfEdges[i], "hidden", false)
//   }
// }

// function invisibliseEdges(listOfEdges) {
//   for (let i = 0; i < listOfEdges.length; i++) {
//     graph.setEdgeAttribute(listOfEdges[i], "hidden", true)
//   }
// }

// function visibliseNodes(listOfUsedNodes) {
//   for (let i = 0; i < listOfUsedNodes.length; i++) {
//     graph.setNodeAttribute(listOfUsedNodes[i], "hidden", false)
//   }
// }

// function invisibliseNodes(listOfUsedNodes) {
//   for (let i = 0; i < listOfUsedNodes.length; i++) {
//     graph.setNodeAttribute(listOfUsedNodes[i], "hidden", true)
//   }
// }

let clickedNode = '';
let clickOn = false;
let prevClicked = '';
// SELECTORS

// const cb_all = document.getElementById("cb-all")
// const cb_bui = document.getElementById("cb-bui")
// const cb_edu = document.getElementById("cb-edu")
// const cb_ene = document.getElementById("cb-ene")
// const cb_fin = document.getElementById("cb-fin")
// const cb_geo = document.getElementById("cb-geo")
// const cb_lan = document.getElementById("cb-lan")
// const cb_tra = document.getElementById("cb-tra")
// const cb_ind = document.getElementById("cb-ind")
// const cb_alm = document.getElementById("cb-alm")
// const cb_off = document.getElementById("cb-off")
// const cb_min = document.getElementById("cb-min")
// const cb_rep = document.getElementById("cb-rep")
// const cb_reh = document.getElementById("cb-reh")
// const cb_avo = document.getElementById("cb-avo")
const search_input = document.getElementById("search-input")
const filter_edges = document.getElementById("filter-edges")
const filter_nodes = document.getElementById("filter-nodes")

sigmaInstance.on("clickNode", (e) => {
  search_input.value = ""
  search()
  clickedNode = e.node;
 // console.log(clickedNode)
  if (!clickOn | (prevClicked != clickedNode)) {
    clickOn = true
 //   console.log(prevClicked)
 //   console.log(clickedNode)

    if (prevClicked != '') {
      let arrayDeselected = getNodesAndEdgesAssociated(prevClicked, 1)
      dehighlightEdges(arrayDeselected[1])
    //  dehighlightNodes(arrayDeselected[0])
      graph.setNodeAttribute(prevClicked, "highlighted", false)
    }
    let arraySelected = getNodesAndEdgesAssociated(clickedNode, 1)
    highlightEdges(arraySelected[1])
  //  highlightNodes(arraySelected[0])
    graph.setNodeAttribute(clickedNode, "highlighted", true)
  }
  else {
    clickOn = false
    let arrayDeselected = getNodesAndEdgesAssociated(clickedNode, 1)
    dehighlightEdges(arrayDeselected[1])
  //  dehighlightNodes(arrayDeselected[0])
    graph.setNodeAttribute(clickedNode, "highlighted", false)
  }
  prevClicked = clickedNode
});

// sigmaInstance.on("clickEdge", (e) => {
//   search_input.value = ""
//   search()
//   let clickedEdge = e.edge;
//   console.log(sigmaInstance.getEdgeDisplayData(clickedEdge))
//   console.log(sigmaInstance)
//   // why is this not working?
// });

//updateColors('s-t')


// function updateSelection() {
//   search_input.value = ""
//   search()
//   let nodesToViz = []
//   graph.forEachNode((node) => {
//     if (((((nodeObject[node].sector).includes('Built environment')) & cb_bui.checked) |
//       (((nodeObject[node].sector).includes('Education')) & cb_edu.checked) |
//       (((nodeObject[node].sector).includes('Energy')) & cb_ene.checked) |
//       (((nodeObject[node].sector).includes('Finance')) & cb_fin.checked) |
//       (((nodeObject[node].sector).includes('Geoengineering')) & cb_geo.checked) |
//       (((nodeObject[node].sector).includes('Industry')) & cb_ind.checked) |
//       (((nodeObject[node].sector).includes('LULUCF')) & cb_lan.checked) |
//       (((nodeObject[node].sector).includes('Transport')) & cb_tra.checked)) & (
//         (((nodeObject[node].hierarchy).includes('avoid')) & cb_avo.checked) |
//         (((nodeObject[node].hierarchy).includes('minimise')) & cb_min.checked) |
//         (((nodeObject[node].hierarchy).includes('replace')) & cb_rep.checked) |
//         (((nodeObject[node].hierarchy).includes('rehabilitate')) & cb_reh.checked) |
//         (((nodeObject[node].hierarchy).includes('offset')) & cb_off.checked))) {
//       nodesToViz.push(node)
//     }
//   });
//   invisibliseNodes(graph.nodes())
//   invisibliseEdges(graph.edges())
//   for (let i = 0; i < nodesToViz.length; i++) {
//     let arraySelected = getNodesAndEdgesAssociated(nodesToViz[i])
//     visibliseEdges(arraySelected[1])
//     visibliseNodes(arraySelected[0])
//   }
//   if (cb_bui.checked & cb_edu.checked & cb_ene.checked & cb_fin.checked & cb_geo.checked & cb_ind.checked & cb_lan.checked & cb_tra.checked) {
//     cb_all.checked = true
//     cb_all.indeterminate = false
//   } else if (cb_bui.checked | cb_edu.checked | cb_ene.checked | cb_fin.checked | cb_geo.checked | cb_ind.checked | cb_lan.checked | cb_tra.checked) {
//     cb_all.indeterminate = true
//   } else {
//     cb_all.indeterminate = false
//     cb_all.checked = false
//   }
//   if (cb_off.checked & cb_min.checked & cb_rep.checked & cb_reh.checked & cb_avo.checked) {
//     cb_alm.checked = true
//     cb_alm.indeterminate = false
//   } else if (cb_off.checked | cb_min.checked | cb_rep.checked | cb_reh.checked | cb_avo.checked) {
//     cb_alm.indeterminate = true
//   } else {
//     cb_alm.indeterminate = false
//     cb_alm.checked = false
//   }
// }

// ADD EVENT LISTENERS FOR SECTORS

// cb_all.addEventListener('click', function () {
//   if (this.checked) {
//     cb_bui.checked = true
//     cb_edu.checked = true
//     cb_ene.checked = true
//     cb_fin.checked = true
//     cb_geo.checked = true
//     cb_ind.checked = true
//     cb_lan.checked = true
//     cb_tra.checked = true
//   } else {
//     cb_bui.checked = false
//     cb_edu.checked = false
//     cb_ene.checked = false
//     cb_fin.checked = false
//     cb_geo.checked = false
//     cb_ind.checked = false
//     cb_lan.checked = false
//     cb_tra.checked = false
//   }
//   updateSelection()
// })

// cb_alm.addEventListener('click', function () {
//   if (this.checked) {
//     cb_off.checked = true
//     cb_min.checked = true
//     cb_rep.checked = true
//     cb_reh.checked = true
//     cb_avo.checked = true
//   } else {
//     cb_off.checked = false
//     cb_min.checked = false
//     cb_rep.checked = false
//     cb_reh.checked = false
//     cb_avo.checked = false
//   }
//   updateSelection()
// })

// cb_bui.addEventListener('click', updateSelection)
// cb_edu.addEventListener('click', updateSelection)
// cb_ene.addEventListener('click', updateSelection)
// cb_fin.addEventListener('click', updateSelection)
// cb_geo.addEventListener('click', updateSelection)
// cb_ind.addEventListener('click', updateSelection)
// cb_lan.addEventListener('click', updateSelection)
// cb_tra.addEventListener('click', updateSelection)
// cb_off.addEventListener('click', updateSelection)
// cb_min.addEventListener('click', updateSelection)
// cb_rep.addEventListener('click', updateSelection)
// cb_reh.addEventListener('click', updateSelection)
// cb_avo.addEventListener('click', updateSelection)

// SEARCH

function search() {
  let searchvalue = document.getElementById("search-input").value.toLowerCase()
  let nodesToHl = []
  let nodesToUnHl = []
 // let edgesToHl = []
 // let edgesToUnHl = []
  if (searchvalue.length < 3) {
    nodesToUnHl = graph.nodes()
 //   edgesToUnHl = graph.edges()
  } else {
    graph.forEachNode((node) => {
      if (node.toLowerCase().includes(searchvalue)) {
        nodesToHl.push(node)
      } else {
        nodesToUnHl.push(node)
      }
    });
    // graph.forEachEdge((edge, attributes) => {
    //   if (attributes.key.toLowerCase().includes(searchvalue)) {
    //     edgesToHl.push(edge)
    //   } else {
    //     edgesToUnHl.push(edge)
    //   }
    // });
  }
  dehighlightNodes(nodesToUnHl)
  highlightNodes(nodesToHl)
 // dehighlightEdges(edgesToUnHl)
 // highlightEdges(edgesToHl)
}


function filterEdges() {
  let toFilter = filter_edges.value
  // listOfEdges = graph.edges()
  graph.forEachEdge((edge) => {
    dehighlightEdge(edge)
    if ((graph.getEdgeAttribute(edge, 'size') > (toFilter*0.4 + 0.01)) & (toFilter > 0)) {
      graph.setEdgeAttribute(edge, 'zIndex', 20)
      graph.setEdgeAttribute(edge, 'color','#303040')
    }
    else {
      graph.setEdgeAttribute(edge, 'zIndex', 1)
      graph.setEdgeAttribute(edge, 'color', '#e0e0e0')
    }
    });

}


function filterNodes() {
  let toFilter = filter_nodes.value
  // listOfNodes = graph.nodes()
  graph.forEachNode((node) => {
    dehighlightNode(node)
    let sizeSqrt = graph.getNodeAttribute(node, 'size')
    if ((sizeSqrt * sizeSqrt) > toFilter) {
      graph.setNodeAttribute(node, 'hidden', false)
    }
    else {
      graph.setNodeAttribute(node, 'hidden', true)
    }
    });

}

search_input.addEventListener('keyup', search)
search_input.addEventListener('cut', search)
search_input.addEventListener('paste', search)
filter_edges.addEventListener('change', filterEdges)
filter_edges.addEventListener('keyup', filterEdges)
filter_edges.addEventListener('cut', filterEdges)
filter_edges.addEventListener('paste', filterEdges)
filter_nodes.addEventListener('change', filterNodes)
filter_nodes.addEventListener('keyup', filterNodes)
filter_nodes.addEventListener('cut', filterNodes)
filter_nodes.addEventListener('paste', filterNodes)

// for radio buttons

// document.getElementById("ra-sec").addEventListener('click', function () { updateColors('sector') })
// document.getElementById("ra-s-t").addEventListener('click', function () { updateColors('s-t') })
// document.getElementById("ra-hie").addEventListener('click', function () { updateColors('hierarchy') })

  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#sigma-container {
  position: relative;
  height: 90vh;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
}

button+button {
  margin-left: 10px;
}
</style>
